
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/pagination",
      function () {
        return require("private-next-pages/components/pagination.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/pagination"])
      });
    }
  